import { useApi } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import type { Activity } from "@/lib/types";
import { Loading, PageHeader } from "@/components/app/PageHeader";

const TONES: Record<string, string> = { screen: "bg-emerald-500/70", media: "bg-blue-500/70", playlist: "bg-cyan-500/70", group: "bg-amber-500/70", user: "bg-fuchsia-500/70" };

export default function ActivityPage() {
  const { data, loading } = useApi<Activity[]>("/activity?limit=300");
  return (
    <div>
      <PageHeader eyebrow="Audit" title="Historique des événements" description="Connexions des écrans, livraisons de contenu et actions des utilisateurs." />
      {loading && !data ? <Loading /> : (
        <div className="panel p-6">
          <ol className="relative space-y-5 border-l border-slate-800 pl-6" data-testid="activity-list">
            {(data || []).map((a) => (
              <li key={a.id} className="relative" data-testid={`activity-item-${a.id}`}>
                <span className={`absolute -left-[29px] top-1.5 h-2.5 w-2.5 rounded-full ring-4 ring-slate-950 ${TONES[a.target_type] || "bg-slate-500"}`} />
                <p className="text-sm text-slate-200">{a.message}</p>
                <p className="mt-0.5 text-xs text-slate-500"><span className="font-mono">{a.action}</span> · {fmtDate(a.created_at)} · {a.actor_email || "appareil"}</p>
              </li>
            ))}
            {data?.length === 0 && <p className="text-sm text-slate-500">Aucun événement.</p>}
          </ol>
        </div>
      )}
    </div>
  );
}
